module.exports = __webpack_public_path__ + "img/icon_in.3686f686.png";